import {Spinner} from 'react-bootstrap';

type TProps = {
	title: string;
	active: string;
	isLoading?: boolean;
};
export const RenderTabTitle = ({title, active, isLoading = false}: TProps) => (
	<span
		style={{
			display: 'flex',
			border: 'none',
			background: 'transparent',
			padding: '0.375rem 0.75rem',
			fontSize: '1rem',
			fontWeight: '400',
			lineHeight: '1.5',
			color: title.includes(active) ? '#212529' : '#9e9e9e',
		}}>
		{isLoading && (
			<Spinner
				as="span"
				animation="border"
				size="sm"
				role="status"
				aria-hidden="true"
				className="mr-2"
			/>
		)}
		{title}
	</span>
);
